import { render, staticRenderFns } from "./wangyi.vue?vue&type=template&id=74b195d6&scoped=true&"
import script from "./wangyi.vue?vue&type=script&lang=js&"
export * from "./wangyi.vue?vue&type=script&lang=js&"
import style0 from "./wangyi.vue?vue&type=style&index=0&id=74b195d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b195d6",
  null
  
)

export default component.exports